<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  export let description: string = ''
  export let expiresAt: string = ''
  export let loading: boolean = false

  const dispatch = createEventDispatcher()

  function handleSubmit(e?: Event) {
    if (e) {
      e.preventDefault()
    }
    
    // Validar que description (nombre) es requerido
    if (!description.trim()) {
      alert('El nombre es requerido')
      return
    }
    
    dispatch('submit', {
      description: description.trim(),
      expiresAt: expiresAt ? new Date(expiresAt).toISOString() : undefined,
    })
  }

  function handleCancel() {
    dispatch('cancel')
  }
</script>

<div class="space-y-5">
  <div>
    <label for="description" class="block text-xs font-bold text-indigo-200 uppercase tracking-wider mb-2">
      Nombre <span class="text-red-400">*</span>
    </label>
    <input
      id="description"
      type="text"
      bind:value={description}
      placeholder="Ej: Tienda Principal, Venta Online, etc."
      class="w-full px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-white focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all outline-none placeholder-white/20"
      disabled={loading}
      required
    />
    <p class="mt-2 text-sm text-indigo-200/60 font-medium">
      Este nombre se mostrará a los usuarios cuando se registren con el código. El código se generará automáticamente.
    </p>
  </div>

  <div>
    <label for="expiresAt" class="block text-xs font-bold text-indigo-200 uppercase tracking-wider mb-2">
      Fecha de Expiración (opcional)
    </label>
    <input
      id="expiresAt"
      type="datetime-local"
      bind:value={expiresAt}
      class="w-full px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-white focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all outline-none"
      disabled={loading}
    />
    <p class="mt-2 text-sm text-indigo-200/60 font-medium">
      Si se establece, el código expirará en esta fecha y hora.
    </p>
  </div>

  <div class="flex gap-3 mt-8">
    <button
      on:click={handleCancel}
      disabled={loading}
      class="flex-1 px-6 py-3 rounded-xl bg-black/30 border border-white/10 text-white hover:bg-white/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-bold"
    >
      Cancelar
    </button>
    <button
      on:click={handleSubmit}
      disabled={loading}
      class="flex-1 px-6 py-3 rounded-xl bg-gradient-to-r from-blue-500 via-purple-500 to-indigo-500 hover:from-blue-400 hover:via-purple-400 hover:to-indigo-400 text-white font-bold shadow-lg shadow-blue-500/30 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? 'Guardando...' : 'Guardar'}
    </button>
  </div>
</div>

